export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',

  // fortune telling
  HEXAGRAM: {
    LIST: '/hexagram',
    CREATE: '/hexagram/create',
    EDIT: (id: string | number = ':id') => `/hexagram/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/hexagram/${id}/detail`,
  },

  // recomment-content
  SUGGESTIONS: {
    LIST: '/suggestions',
    CREATE: '/suggestions/create',
    EDIT: (id: string | number = ':id') => `/suggestions/${id}/edit`,
    DETAIL: (id: string | number = ':id') => `/suggestions/${id}/detail`,
  },

  USER_PROFILE: '/player',

  SETTING: {
    FUNCTION: '/setting/function',
    FEATURE: '/setting/feature',
    CACHE_SYSTEM: '/setting/cache-system',
    USER_MANAGEMENT: '/setting/user-management',
  },
  REWARD: {
    LIST: '/reward',
    CREATE: '/reward/create',
    EDIT: (id: string | number = ':id') => `/reward/${id}/edit`,
  },
  CONFIG: {
    PACKAGE: {
      LIST: '/config/package',
      CREATE: '/config/package/create',
      EDIT: (id: string | number = ':id') => `/config/package/${id}/edit`,
    },
    SHARE_LINK: {
      LIST: '/config/share-link',
      CREATE: '/config/share-link/create',
      EDIT: (id: string | number = ':id') => `/config/share-link/${id}/edit`,
    },
    BACKGROUND: {
      LIST: '/config/background',
      CREATE: '/config/background/create',
      EDIT: (id: string | number = ':id') => `/config/background/${id}/edit`,
    },
    RULES: {
      LIST: '/config/rules',
      CREATE: '/config/rules/create',
      EDIT: (id: string | number = ':id') => `/config/rules/${id}/edit`,
    },
  },
  LOG: {
    PLAYER_TURNS: '/logs/player-turns',
    REWARD: '/logs/reward',
    LUCKY_MONEY: '/logs/lucky-money',
    HEXAGRAM: '/logs/hexagram',
  },

  LEADER_BOARD_PLAYER: {
    LIST: '/leaderboards/player',
    CREATE: '/leaderboards/player/create',
  },

  LEADER_BOARD_FANCLUB: {
    LIST: '/leaderboards/fanclub',
    CREATE: '/leaderboards/fanclub/create',
  },

  DEMO: '/demo',
  NOT_FOUND: '/not-found',
  FORBIDDEN: '/403',
};
